import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FieldBody } from 'web-ui-components/lib/molecules/forms';
import { Input } from 'web-ui-components/lib/atoms/forms';
import styles from '../BacsPaymentStyles';
import { cleanIllegalBACSCharacters } from '../../../../helpers/fieldHelpers';

class TextField extends Component {
	constructor(props) {
		super(props);
		this.handleOnBlur = this.handleOnBlur.bind(this);
		this.handleOnFocus = this.handleOnFocus.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.state = {
			value: props.value,
		};
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.value !== nextProps.value) this.setState({ value: nextProps.value });
	}

	handleOnBlur() {
		const { value } = this.state;
		this.props.onBlur(value);
	}

	handleOnFocus() {
		const { value } = this.state;
		const { onFocus } = this.props;
		if (onFocus) {
			this.props.onFocus(value);
		}
	}

	handleChange(event) {
		this.setState({
			value: cleanIllegalBACSCharacters(event.target.value),
		});
	}

	render() {
		const { id, maxLength, disabled, cyLabel, dataTestId } = this.props;
		const { value } = this.state;
		return (
			<FieldBody>
				<Input
					data-cy={cyLabel}
					id={id}
					type="text"
					value={value}
					onChange={this.handleChange}
					onBlur={this.handleOnBlur}
					onFocus={this.handleOnFocus}
					maxLength={maxLength}
					className={styles.main__input}
					autoComplete="off"
					disabled={disabled}
					data-test-id={dataTestId}
				/>
			</FieldBody>
		);
	}
}

TextField.propTypes = {
	id: PropTypes.string.isRequired,
	value: PropTypes.string,
	onBlur: PropTypes.func.isRequired,
	onFocus: PropTypes.func,
	maxLength: PropTypes.string.isRequired,
	disabled: PropTypes.bool,
};

export default TextField;
